
import request from '@/utils/request'
import { preflightService } from '@/utils/request'

export default {
  /** 查询版本号列表 */
  getVersionList(data) {
    return request({
      url: '/common/commonVersionConfig/pageList',
      method: 'POST',
      data
    })
  },
  /** 新增业务版本 */
  createVersion(data) {
    return request({
      url: '/common/commonVersionConfig/create',
      method: 'POST',
      data
    })
  },
  /** 更新业务版本 */
  updateVersion(data) {
    return request({
      url: '/common/commonVersionConfig/update',
      method: 'POST',
      data
    })
  },
  /** 删除业务版本 */
  deleteVersion(data) {
    return request({
      url: '/common/commonVersionConfig/delete',
      method: 'POST',
      data
    })
  },
  /** 刷新业务版本 */
  refreshVersion(data) {
    return request({
      url: '/common/commonVersionConfig/refreshCache',
      method: 'POST',
      data
    })
  },

  /** 检查当前是否存在当前版本 */
  getCurrentVersionExist(data) {
    return preflightService({
      url: '/common/commonVersionConfig/getVersionConfig',
      method: 'POST',
      data
    })
  }
}
